import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import { Button, Modal, Select } from 'redpoints-front-components/index';

import { linksManagementEnforcementDisruptedReasonsFetch } from '../../../actions/linksManagementActions';
import {
  getLinksManagementEnforcementDisruptedReasonsList,
  getLinksManagementEnforcementDisruptedReasonsListIsLoading,
} from '../../../reducers/tasks/linksManagement';
import { translate } from '../../../helpers/languageHelper';
import { byCaseInsensitive } from '../../../helpers/sortingHelpers';

const LinksManagementEnforcementDisruptedModal = ({
  isLoading,
  linksManagementEnforcementDisruptedReasonsFetch,
  onAccept,
  onCancel,
  reasonsList,
}) => {
  const [selectedReason, setSelectedReason] = useState({});

  useEffect(() => {
    if (!isLoading && !reasonsList) {
      linksManagementEnforcementDisruptedReasonsFetch();
    }
  }, [isLoading, linksManagementEnforcementDisruptedReasonsFetch, reasonsList]);

  const handleAccept = useCallback(() => {
    if (selectedReason) {
      onAccept(selectedReason)();
    }
  }, [onAccept, selectedReason]);

  const handleChange = useCallback(
    reasonId => {
      const selectedReason = reasonsList.find(
        reason => reason.reasonId === reasonId
      );
      setSelectedReason(selectedReason);
    },
    [reasonsList]
  );

  const reasonsOptions = (reasonsList || [])
    .map(({ reasonDescription, reasonId }) => ({
      reasonId,
      reasonDescription: translate(reasonDescription),
    }))
    .sort(byCaseInsensitive({ property: 'reasonDescription' }));

  return (
    <Modal
      visible={true}
      onCancel={onCancel}
      footer={
        <>
          <div />
          <Button
            aria-label="reasons-button"
            disabled={!selectedReason.reasonId}
            loading={isLoading}
            onClick={handleAccept}
            type="primary"
          >
            {translate('actions.save')}
          </Button>
        </>
      }
    >
      <Select
        aria-label="reasons-select"
        data={reasonsOptions}
        disabled={isLoading || !reasonsList}
        label={translate(
          'tasks.links_management.modal.enforcement_disrupted_reason_label'
        )}
        mapping={{ key: 'reasonId', value: 'reasonDescription' }}
        onChange={handleChange}
        value={selectedReason.reasonId}
      />
    </Modal>
  );
};

LinksManagementEnforcementDisruptedModal.propTypes = {
  isLoading: PropTypes.bool,
  onAccept: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  reasonsList: PropTypes.arrayOf(
    PropTypes.shape({
      reasonId: PropTypes.number.isRequired,
      reasonDescription: PropTypes.string.isRequired,
    })
  ),
};

const mapStateToProps = state => ({
  isLoading: getLinksManagementEnforcementDisruptedReasonsListIsLoading(state),
  reasonsList: getLinksManagementEnforcementDisruptedReasonsList(state),
});

export default connect(mapStateToProps, {
  linksManagementEnforcementDisruptedReasonsFetch,
})(LinksManagementEnforcementDisruptedModal);
